import { SELECIONAR_DATA_VOLTA } from '../types';


export default function limparDataIda () {
  return {
    type: SELECIONAR_DATA_VOLTA,
    payload: null
  }
}
